import Http from "../../http/client";
import {RequestQueryBuilder} from "@nestjsx/crud-request";

export default async (userId) => {
  const qb = RequestQueryBuilder.create();

  qb.setFilter({ field: "user.id", operator: "$eq", value: userId });

  qb.setJoin({field: 'userDevice'});
  qb.setJoin({field: 'user', fields: ['id']});

  const response = await Http.get('admin/sessions', {
    params: qb.queryObject
  });

  return response.data;
}
